import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Outlet, useLocation } from 'react-router-dom';

const Wrapper = () => {
    const location = useLocation();
    return (
        <>
            <Header />
            <div style={{ zIndex: 10, background: '#ffffff' }}>
                <Outlet />
            </div>
            {location.pathname !== '/login' && <Footer />}
        </>
    );
};

export default Wrapper;
